import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../auth.service';

@Component({
  standalone: true,
  imports: [CommonModule],
  template: ``,
})
export class SilentCallbackComponent implements OnInit {

  constructor(private authService: AuthService) {}

  ngOnInit(): void {
    console.log('SilentCallbackComponent ngOnInit');
    this.authService
      .silentSignInAuthentication()
      .catch(err => {
        // Silent renew başarısız olabilir → logout YOK
        console.warn('Silent renew failed:', err);
      });
  }
}



// import { Component, OnInit } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { AuthService } from '../../auth.service';
// import { UtilsService } from '@dabnet-kamu/libs/ui';
//
// @Component({
//   standalone: true,
//   imports: [CommonModule],
//   template: ``,
//   styles: [],
// })
// export class SilentCallbackComponent implements OnInit {
//   constructor(private _authService: AuthService, private utilService: UtilsService
//   ) {
//
//   }
//
//   ngOnInit(): void {
//     this._authService.silentSignInAuthentication()
//       .catch((err) => {
//         this._authService.startLogout();
//       });
//   }
//
// }


